// extracted by mini-css-extract-plugin
export default {"Assistance":"Assistance_Assistance__o0ER-","para":"Assistance_para__lWmEF","list":"Assistance_list__fVmXX","view-more":"Assistance_view-more__r0y88"};